import styled from "styled-components";

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
`;

export const Text = styled.p`
  display: -webkit-box;
  max-width: 690px;
  min-height: 31px;
  line-height: 150%;
`;
